import { createSelector } from "reselect";
import { isEmpty, forIn, isNull } from "lodash";

const defaultUserProfile = {
  birthDate: null,
  birthPlace: null,
  maritalStatus: null,
  children: null,
  motherTongue: null,
  religion: null,
  community: null,
  caste: null,
  address: null,
  information: null
};
//EXTRACT THE PART OF THE STATE
const getData = state => {
  const userProfile = state.user.profile;
  //get all static data
  const { data } = state;
  //if any of the static data is empty return the default value
  if (
    isEmpty(data.maritalStatus) ||
    isEmpty(data.motherTongue) ||
    isEmpty(data.religion) ||
    isEmpty(data.caste)
  ) {
    return defaultUserProfile;
  }
  //if preference is empty return the default value
  if (isEmpty(userProfile)) {
    return defaultUserProfile;
  }
  //format the preference and return it
  try {
    let object = {};
    forIn(userProfile, (value, key) => {
      if (key === "birthDate") {
        if (isNull(value)) {
          object[key] = null;
        } else {
          object[key] = value.toDate();
        }
      } else if (key === "birthPlace") {
        if (isNull(value)) {
          object[key] = null;
        } else {
          object[key] = value.formatted_address;
        }
      } else if (key === "maritalStatus") {
        if (isNull(value)) {
          object[key] = null;
        } else {
          if (data[key][value]) {
            object[key] = {
              label: data[key][value].label,
              value: data[key][value].value,
              description: data[key][value].description
            };
          }
        }
      } else if (key === "children") {
        if (isNull(value)) {
          object[key] = null;
        } else {
          if (value === 0) {
            object[key] = { label: "None", value };
          } else {
            object[key] = { label: value, value };
          }
        }
      } else if (key === "motherTongue") {
        if (isNull(value)) {
          object[key] = null;
        } else {
          if (data[key][value]) {
            object[key] = {
              label: data[key][value].label,
              value: data[key][value].value,
              description: data[key][value].description
            };
          }
        }
      } else if (key === "religion") {
        if (isNull(value)) {
          object[key] = null;
        } else {
          if (data[key][value]) {
            object[key] = {
              label: data[key][value].label,
              value: data[key][value].value,
              description: data[key][value].description
            };
          }
        }
      } else if (key === "community") {
        if (isNull(value)) {
          object[key] = null;
        } else {
          if (isEmpty(data.community)) {
            object[key] = value;
          } else {
            if (data.community[value]) {
              object[key] = {
                label: data.community[value].label,
                value: data.community[value].value,
                description: data.community[value].description
              };
            }
          }
        }
      } else if (key === "caste") {
        if (isNull(value)) {
          object[key] = null;
        } else {
          if (data[key][value]) {
            object[key] = {
              label: data[key][value].label,
              value: data[key][value].value,
              description: data[key][value].description
            };
          }
        }
      } else if (key === "address") {
        if (isNull(value)) {
          object[key] = null;
        } else {
          object[key] = value.formatted_address;
        }
      } else if (key === "information") {
        if (isNull(value)) {
          object[key] = "";
        } else {
          object[key] = value;
        }
      } else {
        //do nothing
      }
    });
    return object;
  } catch (error) {
    return defaultUserProfile;
  }
};
//VERIFY IF THE JWT IS SET
const getMyUserBasicProfile = createSelector(
  getData,
  userProfile => userProfile
);
export default getMyUserBasicProfile;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getMyUserBasicProfile.js